
import { getFutureLayerAppUrlWithReturnTo } from "@/futurelayer/app/app";
import { getClaimUrl } from "@/futurelayer/connector/connector";
import { singularityStore } from "@/store/store";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Prop } from "vue-property-decorator";
import NiceButton from "../UI/NiceButton.vue";
import IconButton from "../UI/IconButton.vue";

@Component({
  components: {
    NiceButton,
    IconButton
  }
})
export default class OutOfCreditsModal extends Vue {
  @Prop()
  offerText!: string;

  get isOpen() {
    return singularityStore.isOutOfCreditsModalOpen;
  }

  set isOpen(value: boolean) {
    singularityStore.setOutOfCreditsModalOpen(value);
  }

  get siteStatus() {
    return singularityStore.siteStatus;
  }

  get isSiteClaimed(): boolean {
    return this.siteStatus.isClaimed;
  }

  get buttonText(): string {
    return this.isSiteClaimed ? "Upgrade Plan" : "Register Free";
  }

  closeModal() {
    singularityStore.setOutOfCreditsModalOpen(false);
  }

  handleAction() {
    if (this.isSiteClaimed) {
      window.location.href = getFutureLayerAppUrlWithReturnTo("/pricing");
    } else {
      const claimUrl = getClaimUrl();
      if (claimUrl) {
        const returnTo = encodeURIComponent(window.location.href);
        const urlWithReturn = `${claimUrl}&return_to=${returnTo}`;
        window.location.href = urlWithReturn;
      }
    }
  }
}
